import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import {
  ISupplierResponseItemCommentsResponse,
  ISupplierItemAnswersResponse,
  IProductConflictsResponse,
  IConflictResolution,
} from "../interface/responses/ISupplierResponseCategoriesResponse";
import { IBaseResponse } from "../interface/responses/IBaseResponse";

class SupplierResponseSingleService {
  constructor() {}

  async getItemComments(
    itemId: string,
    productId: string
  ): Promise<IBaseResponse<ISupplierResponseItemCommentsResponse>> {
    const response = await httpClient.get<ISupplierResponseItemCommentsResponse>(
      API_ROUTES.SpecificationSupplierResponses.itemComments(itemId, productId)
    );
    // API returns data directly (no IBaseResponse wrapper)
    // If response already has data property, use it; otherwise wrap the response
    if (response && typeof response === 'object' && 'data' in response) {
      return response as IBaseResponse<ISupplierResponseItemCommentsResponse>;
    }
    // If API returns data directly, wrap it in IBaseResponse format
    return {
      success: true,
      data: response as unknown as ISupplierResponseItemCommentsResponse,
    };
  }

  async getSupplierItemAnswers(
    specificationId: string,
    productId: string
  ): Promise<IBaseResponse<ISupplierItemAnswersResponse>> {
    const response = await httpClient.get<ISupplierItemAnswersResponse>(
      API_ROUTES.SpecificationSupplierResponses.supplierItemAnswers(
        specificationId,
        productId
      )
    );
    // API returns data directly (no IBaseResponse wrapper)
    // If response already has data property, use it; otherwise wrap the response
    if (response && typeof response === 'object' && 'data' in response) {
      return response as IBaseResponse<ISupplierItemAnswersResponse>;
    }
    // If API returns data directly, wrap it in IBaseResponse format
    return {
      success: true,
      data: response as unknown as ISupplierItemAnswersResponse,
    };
  }

  async getProductConflicts(
    productId: string,
    specificationId: string
  ): Promise<IBaseResponse<IProductConflictsResponse>> {
    const response = await httpClient.get<IProductConflictsResponse>(
      API_ROUTES.SpecificationSupplierResponses.conflicts(
        productId,
        specificationId
      )
    );
    if (response && typeof response === "object" && "data" in response) {
      return response as IBaseResponse<IProductConflictsResponse>;
    }
    return {
      success: true,
      data: response as unknown as IProductConflictsResponse,
    };
  }

  async createOrUpdateResolution(
    itemId: string,
    productId: string,
    specificationId: string,
    formData: FormData
  ): Promise<IBaseResponse<IConflictResolution>> {
    const response = await httpClient.post<IConflictResolution>(
      API_ROUTES.SpecificationSupplierResponses.resolution(
        itemId,
        productId,
        specificationId
      ),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response && typeof response === "object" && "data" in response) {
      return response as IBaseResponse<IConflictResolution>;
    }
    return {
      success: true,
      data: response as unknown as IConflictResolution,
    };
  }
}

export const supplierResponseSingleService = new SupplierResponseSingleService();

